import { createSlice } from "@reduxjs/toolkit";

interface ProjectLocationState {
    refreshKey: number; 
}

const initialState: ProjectLocationState = {
    refreshKey: 0, 
};

const refreshKeySlice = createSlice({
    name: "projectLocation",
    initialState,
    reducers: {
        refreshProjectLocation: (state) => {
            state.refreshKey += 1; 
        },
    },
});

export const { refreshProjectLocation } = refreshKeySlice.actions;
export default refreshKeySlice.reducer;
